import { api_GET, api_POST, api_PUT } from "./_api.js";

const formularioVistoria_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FormularioVistoria/GetList/`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FormularioVistoria/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("FormularioVistoria", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("FormularioVistoria", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default formularioVistoria_api;